import React from 'react';
import { Col, Container } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import Forms from './components/Forms/index';

const CadastrosProgramacaoMain = () => {
  return (
    <Container fluid>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Início', path: '/' },
            { name: 'Programação', path: '/pages/containers/programacao' },
            { name: 'Criar/Editar' },
          ]}
        />
      </Col>
      <Forms />
    </Container>
  );
};

export default CadastrosProgramacaoMain;
